import { FC, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, DialogContent, Divider, Typography } from '@mui/material';
import { YearMonthPiker } from 'ui/YearMonthPiker';
import { TRequestPastReportsDialogProps } from './types';

const parseDefaultDate = (
	isoDate: string | null | undefined,
): { year: number; month: number } | null => {
	if (!isoDate) return null;
	const [y, m] = isoDate.split('-').map(Number);
	if (!y || !m) return null;
	return { year: y, month: m };
};

const formatStartDate = (year: number, month: number): string =>
	`${year}-${month.toString().padStart(2, '0')}-01`;

export const RequestPastReportsDialog: FC<TRequestPastReportsDialogProps> = ({
	open,
	setClose,
	defaultStartDate,
	onConfirm,
}) => {
	const defaultParsed = parseDefaultDate(defaultStartDate ?? undefined);
	const [selected, setSelected] = useState<{ year: number; month: number } | null>();

	const handleConfirm = () => {
		if (!selected) return;
		onConfirm(formatStartDate(selected.year, selected.month));
		setClose();
	};

	return (
		<Dialog
			open={open}
			onClose={setClose}
			aria-labelledby="request-past-reports-dialog-title"
			aria-describedby="request-past-reports-dialog-description"
			sx={{ '& .MuiDialog-paper': { width: '380px', maxWidth: 'none' } }}
		>
			<DialogTitle id="request-past-reports-dialog-title" color="primary">
				Request Past Reports
			</DialogTitle>
			<DialogContent>
				<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					<YearMonthPiker
						// initialYear={defaultParsed?.year ?? null}
						// initialMonth={defaultParsed?.month ?? null}
						onChange={(date) => setSelected({ year: date.year, month: date.month })}
						numberOfYears={6}
					/>
					{selected?.month && (
						<>
							<Divider
								flexItem
								sx={{ borderColor: 'primary.light', borderWidth: '1.2px', my: 2, mx: 4 }}
							/>
							<Typography sx={{ color: 'primary.main' }}>
								Start date:{' '}
								<b>{selected?.month ? formatStartDate(selected.year, selected.month) : '—'}</b>
							</Typography>
						</>
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={handleConfirm} autoFocus disabled={!selected?.month}>
					Request
				</Button>
			</DialogActions>
		</Dialog>
	);
};
